var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1999 3.92309C2.1999 2.01133 3.81168 0.461548 5.7999 0.461548H14.0543C15.0091 0.461548 15.9248 0.826245 16.5999 1.47541L22.7455 7.38463C23.4206 8.03379 23.7999 8.91425 23.7999 9.8323V24.6923C23.7999 26.6041 22.1881 28.1539 20.1999 28.1539H17.4499C19.16 26.3166 20.1999 23.8905 20.1999 21.2308C20.1999 15.4955 15.3646 10.8462 9.3999 10.8462C6.63383 10.8462 4.11063 11.846 2.1999 13.4904V3.92309Z",
    fill: "#AABCCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3999 14.3077C5.42345 14.3077 2.1999 17.4073 2.1999 21.2308C2.1999 22.5139 2.56403 23.7168 3.19704 24.7474L0.92711 26.93C0.224167 27.6059 0.224166 28.7018 0.92711 29.3777C1.63005 30.0536 2.76975 30.0536 3.47269 29.3777L5.74263 27.1951C6.81442 27.8037 8.06541 28.1539 9.3999 28.1539C13.3764 28.1539 16.5999 25.0543 16.5999 21.2308C16.5999 17.4073 13.3764 14.3077 9.3999 14.3077ZM5.7999 21.2308C5.7999 19.319 7.41168 17.7692 9.3999 17.7692C11.3881 17.7692 12.9999 19.319 12.9999 21.2308C12.9999 23.1425 11.3881 24.6923 9.3999 24.6923C8.40529 24.6923 7.50776 24.3068 6.85432 23.6785C6.20088 23.0501 5.7999 22.1871 5.7999 21.2308Z",
    fill: "#AABCCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.925559b0.svg";
export { ForwardRef as ReactComponent };